import { useEffect } from 'react';
import TermsImage from '../../assets/terms-of-use.png';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileNavigation from '../../components/MobileNavigation';

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="flex flex-col min-h-dvh">
        <Header />
        <MobileNavigation />

        <main className="w-full max-w-4xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-8">
          {/* Top Image */}
          <div className="flex justify-center mb-20">
            <img 
              src={TermsImage} 
              alt="Terms Illustration" 
              className="w-full max-w-5xl h-auto object-contain"
            />
          </div>

          {/* Section 1: Introduction */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Introduction</h2>
            <p className="mb-5">
              <span className="font-semibold">1.1</span> Bienvenue sur le Maketplace B2B en Ligne de Neobox Inc. ("la Plateforme"). Ces conditions générales d'utilisation régissent votre utilisation de la Plateforme et constituent un accord légalement contraignant entre vous et Neobox Inc.
            </p>
            <p className="mb-6">
              <span className="font-semibold">1.2</span> En accédant ou en utilisant la Plateforme, vous acceptez de respecter et d'être lié par ces conditions. Si vous n'êtes pas d'accord avec une partie de ces conditions, vous ne pouvez pas utiliser la Plateforme.
            </p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 2: Inscription au Compte */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Inscription au Compte</h2>
            <p className="mb-5">
              <span className="font-semibold">2.1</span> Pour accéder à certaines fonctionnalités de la Plateforme, vous devez vous inscrire à un compte. Vous acceptez de fournir des informations exactes, actuelles et complètes lors du processus d'inscription et de mettre à jour ces informations pour les maintenir exactes, actuelles et complètes.
            </p>
            <p className="mb-6">
              <span className="font-semibold">2.2</span> Vous êtes responsable de maintenir la confidentialité de votre compte et de votre mot de passe, ainsi que de restreindre l'accès à votre compte. Vous acceptez de prendre la responsabilité de toutes les activités qui se déroulent sous votre compte ou mot de passe.
            </p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 3: Annonces et Informations sur les Produits */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Annonces et Informations sur les Produits</h2>
            <p className="mb-5">
              <span className="font-semibold">3.1</span> Vous acceptez de fournir des informations exactes et à jour concernant votre entreprise, vos produits et services lors de la création d'une annonce sur Neobox Inc.
            </p>
            <p className="mb-6">
              <span className="font-semibold">3.2</span> Neobox Inc. se réserve le droit de vérifier et, si nécessaire, de supprimer tout contenu qui enfreint ces conditions ou qui est jugé inapproprié.
            </p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 4: Commandes et Transactions */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Commandes et Transactions</h2>
            <p className="mb-5">
              <span className="font-semibold">4.1</span> Toutes les commandes et transactions sont soumises à l'acceptation à la fois de l'acheteur et du vendeur. Neobox Inc. n'est pas partie à la transaction réelle entre les acheteurs et les vendeurs.
            </p>
            <p className="mb-6">
              <span className="font-semibold">4.2</span> Les vendeurs acceptent de traiter les commandes rapidement et conformément aux spécifications indiquées dans l'annonce.
            </p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 5: Paiements et Frais */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Paiements et Frais</h2>

            <span className="font-semibold">5.1 Responsabilité des Paiements</span>
            <p className="mb-5">
            Neobox Inc. agit en tant qu’intermédiaire de confiance pour sécuriser les transactions entre les acheteurs et les vendeurs. Les paiements effectués par les acheteurs sont transférés à Neobox Inc., qui les retient jusqu’à confirmation de la livraison ou de l’exécution complète des obligations du vendeur. En cas de manquement du vendeur (ex. : défaut de livraison, non-conformité du produit) ou d’annulation légitime d’une transaction, Neobox Inc. garantit le remboursement intégral ou partiel de l’acheteur dans un délai de 14 jours ouvrables, sous réserve de vérification des preuves fournies.
            </p>

            <span className="font-semibold">5.2 Frais de Service</span>
            <p className="mb-5">
            Neobox Inc. peut prélever des frais de service (ex. : commission sur les transactions) selon les modalités communiquées aux utilisateurs. Ces frais sont non remboursables, sauf en cas d’annulation imputable à Neobox Inc.
            </p>

            <div className="mb-5">
              <span className="font-semibold">5.3 Litiges et Médiation</span>
              <p className="mt-4 mb-4">En cas de désaccord sur une transaction, Neobox Inc. se réserve le droit de :</p>
              <ul className="list-disc list-inside ml-8 space-y-4">
                <li><span className="font-semibold">a)</span> Geler les fonds en attente pendant la durée de l’enquête.</li>
                <li><span className="font-semibold">b)</span> Imposer une solution équitable (remboursement, compensation, etc.) basée sur les preuves fournies par les parties.</li>
              </ul>
            </div>

            <div className="mb-6">
              <span className="font-semibold">5.4 Exonération de Responsabilité</span>
              <p className="mt-4 mb-4">Neobox Inc. n’est pas responsable :</p>
              <ul className="list-disc list-inside ml-8 space-y-4">
                <li>Des erreurs ou retards causés par des tiers prestataires de paiement (ex. : banques, processeurs de carte).</li>
                <li>Des fluctuations de devises ou des frais bancaires externes.</li>
              </ul>
            </div>

          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 6 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Propriété Intellectuelle</h2>
            <p className="mb-6"><span className="font-semibold">6.1</span> Les utilisateurs conservent la propriété de leurs droits de propriété intellectuelle. En utilisant la Plateforme, vous accordez à Neobox Inc. une licence non exclusive, mondiale et sans redevance pour utiliser, afficher et distribuer votre contenu.</p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 7 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Résiliation</h2>
            <p className="mb-5"><span className="font-semibold">7.1</span> Neobox Inc. se réserve le droit de suspendre ou de résilier votre compte et l'accès à la Plateforme à sa discrétion, avec ou sans motif et avec ou sans préavis.</p>
            <p className="mb-5"><span className="font-semibold">7.2</span> En cas de résiliation, toutes les obligations en cours, y compris, mais sans s'y limiter, les obligations de paiement, restent exécutoires.</p>
            <div className="mb-5">
              <span className="font-semibold">7.3 Non-Compétition et Non-Sollicitation</span>
              <p className="mt-4 mb-4">Après la résiliation de votre compte ou la cessation de votre utilisation de la Plateforme, vous vous engagez, pour une période de trois (3) ans, à :</p>
              <ul className="list-disc list-inside ml-8 space-y-4">
                <li><span className="font-semibold">a)</span> Ne pas exercer, directement ou indirectement, une activité concurrente à la Plateforme, y compris (sans s’y limiter) la participation à, l’exploitation ou la promotion de toute place de marché B2B similaire.</li>
                <li><span className="font-semibold">b)</span> Ne pas solliciter, détourner ou tenter de solliciter tout client acheteur avec lequel vous avez interagi via la Plateforme, ou dont vous avez obtenu les informations grâce à Neobox Inc.</li>
              </ul>
            </div>
            <div className="mb-6">
              <span className="font-semibold">7.4 Réparations en Cas de Violation</span>
              <p className="mt-4 mb-4">Vous reconnaissez que toute violation des clauses <span className="font-semibold">7.3(a)</span> ou <span className="font-semibold">7.3(b)</span> causerait un préjudice irréparable à Neobox Inc. Celle-ci se réserve le droit de :</p>
              <ul className="list-disc list-inside ml-8 space-y-4">
                <li>Demander des mesures injonctives (sans obligation de prouver un préjudice réel).</li>
                <li>Réclamer des dommages-intérêts compensatoires ou punitifs.</li>
                <li>Suspendre immédiatement tout compte lié à la violation.</li>
              </ul>
            </div>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 8 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Limitation de Responsabilité</h2>
            <div className="mb-5">
              <p className="mb-4">
                <span className="font-semibold">8.1</span><span> Dans la mesure permise par la loi, Neobox Inc. ne sera pas responsable :</span>
              </p>
              <ul className="list-disc list-inside ml-8 space-y-4">
                <li>Des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs.</li>
                <li>De toute perte de profits, de revenus, ou de données.</li>
                <li>Des litiges liés aux tiers prestataires de paiement ou à des erreurs techniques externes.</li>
              </ul>
            </div>
            <div className="mb-6">
              <span className="font-semibold">8.2 Exceptions</span>
              <p className="mt-4 mb-4">La limitation de responsabilité ne s’applique pas :</p>
              <ul className="list-disc list-inside ml-8 space-y-4">
                <li>En cas de faute grave ou de négligence volontaire de Neobox Inc.</li>
                <li>Pour les obligations explicites de remboursement décrites à l’article <span className="font-semibold">5.1</span>.</li>
                <li>Si la loi québécoise impose une responsabilité inaliénable.</li>
              </ul>
            </div>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 9 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Droit Applicable</h2>
            <p className="mb-6"><span className="font-semibold">9.1</span> Ces conditions générales seront régies par et interprétées conformément aux lois de la province de Québec (Canada), notamment le Code civil du Québec, sans égard à ses principes de conflit de lois. Tout litige relève de la compétence exclusive des tribunaux de Montréal.</p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 10 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Modifications des Conditions</h2>
            <p className="mb-6"><span className="font-semibold">10.1</span> Neobox Inc. se réserve le droit de mettre à jour ou de modifier ces conditions générales à tout moment. Votre utilisation continue de la Plateforme vaut acceptation des nouvelles conditions.</p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Section 11 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-5">Dispositions Générales</h2>
            <span className="font-semibold">11.1 Divisibilité</span>
            <p className="mb-5">Si une clause est jugée invalide par un tribunal, les autres restent pleinement applicables.</p>
            <span className="font-semibold">11.2 Renonciation</span>
            <p className="mb-5">Le fait que Neobox Inc. ne fasse pas appliquer une disposition ne constitue pas une renonciation à ses droits futurs.</p>
          </section>
          <hr className="border-[#dddddd] mb-12" />

          {/* Bottom section */}
          <section className="mb-36">
            <p className="font-semibold">En utilisant la Plateforme, vous reconnaissez avoir lu, compris et accepté d'être lié par ces conditions générales, y compris les obligations de non-compétition et non-sollicitation post-résiliation.</p>
          </section>
        </main>
      </section>

      <Footer />
    </>
  );
};

export default TermsOfUse;
